import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import rideReducer from './slices/rideSlice';
import vehicleReducer from './slices/vehicleSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    rides: rideReducer,
    vehicles: vehicleReducer,
  },
});

export default store;
